import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { useMutation } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { PatientsApi } from '../../../apis/PatientsApi/PatientsApi.ts';
import { IPatientsInitialProfilePayload, IPatientsProfilePayload } from '../Patient.ts';
import { useSessionProvider } from '../../../provider/sessionContext.tsx';

export function usePutPatientsInitialProfile() {
    const { currentUser, setCurrentUser } = useSessionProvider();

    return useMutation<number, AppMedError, IPatientsInitialProfilePayload>({
        mutationKey: [QueryKeys.patient, 'profile'],
        mutationFn: async (variables: IPatientsProfilePayload) => {
            return await PatientsApi.putPatientInitialProfile(variables);
        },
        onSuccess: () => {
            localStorage.setItem(
                'currentUser',
                JSON.stringify({
                    ...currentUser,
                    hasProfile: true,
                    redirect: '/patientDashboard',
                }),
            );
            setCurrentUser({
                ...currentUser,
                hasProfile: true,
                redirect: '/patientDashboard',
            });

            return;
        },
        onError: (error) => {
            console.error('Login failed:', error.message);
        },
    });
}
